import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useOnlineStatus } from "../../../components/Hooks/useOnlineStatus";

type DiggingLoadingSummaryTableFooterProps = {
  isLoading: boolean
  loads?: number
  tonnes?: number
}

const DiggingLoadingSummaryTableFooter: React.FC<DiggingLoadingSummaryTableFooterProps> = ({
  isLoading,
  loads,
  tonnes
}) => {
  const isOnline = useOnlineStatus();
  // Note: tonnage is derived by the server from the truck that carried the loads, so a shift entered
  // offline knows its loads but not its tonnes. Showing nothing there read as zero tonnes moved;
  // "TBC" says it is coming, and only while offline - a genuine zero online still reads as zero.
  const tonnesDisplay = !isOnline && !tonnes ? "TBC" : tonnes;

  return (
    <div
      className="bg-theme-surface-2 flex items-end md:justify-end md:items-center px-2 py-4 border-x border-b border-t-4 mb-4 border-t-theme-table-row-border border-theme-table-heading-border fade-up gap-8 w-full column flex-col md:flex-row ">
      <div className="flex items-center">
        <span className="p-4 text-2xl text-theme-table-row-contrast translate-y-1 transition ease-out text-nowrap">Total Loads:</span>
        <span className="py-4 px-6 flex justify-center items-center font-bold bg-theme-warning rounded relative min-w-0">
          <div className={`absolute inset-0 flex items-center justify-center transition-opacity ${isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <FontAwesomeIcon icon={faSpinner} spin className="!text-5xl !text-theme-table-row-contrast !w-8 !h-8" />
          </div>
          <span className={`text-4xl transition-opacity ${isLoading ? 'opacity-0' : 'opacity-100'}`}>
            {loads}
          </span>
        </span>
      </div>
      <div className="flex items-center">
        <span className="p-4 text-2xl text-theme-table-row-contrast translate-y-1 transition ease-out text-nowrap">Total Tonnes:</span>
        <span className="py-4 px-6 flex justify-center items-center font-bold bg-theme-warning rounded relative min-w-0">
          <div className={`absolute inset-0 flex items-center justify-center transition-opacity ${isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <FontAwesomeIcon icon={faSpinner} spin className="text-5xl text-theme-table-row-contrast !w-8 !h-8" />
          </div>
          <span className={`text-4xl transition-opacity ${isLoading ? 'opacity-0' : 'opacity-100'}`}>
            {tonnesDisplay}
          </span>
        </span>
      </div>
    </div>
  )
};

export default DiggingLoadingSummaryTableFooter;